import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import FileUpload from "../../form/FileUpload";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";

export interface StoreBrandFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  id: number;
  defaultValues: StoreBrandFormData;
  cover: string; 
  onSuccess?:()=>void
}

const UpdateStoreTypeForm: React.FC<Props> = ({ id, defaultValues, cover ,onSuccess}) => {
  const { t } = useTranslation();

  // state for a newly selected file (if user uploads a new logo)
  const [newCoverFile, setNewCoverFile] = useState<File | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<StoreBrandFormData>({
    defaultValues,
  });

  
    const {loading,updateResource} = useUpdateResource();
    
      const onSubmit: SubmitHandler<StoreBrandFormData> = async (data) => {
             const formData = new FormData();
            const languages = data.languages.map((da)=>({name:da.title,languageCode:da.languageCode}));
            formData.append("languages",JSON.stringify(languages))
            if(newCoverFile){
                formData.append("image",cover);
            }
            await  updateResource(`type/update/${id}`, formData, "admin",{
                method: "PUT",
                successMessage: t("update_success"),
                invalidateQueries:["store-types-by-admin"],
              });
            if (onSuccess) onSuccess();
      };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        {/* English Title */}
        <InputField
          placeholder=""
          label={t("title_en")}
          register={register("languages.0.title", {
            required: t("required_field"),
          })}
          error={errors.languages?.[0]?.title}
        />

        {/* Arabic Title */}
        <InputField
          placeholder=""
          label={t("title_ar")}
          register={register("languages.1.title", {
            required: t("required_field"),
          })}
          error={errors.languages?.[1]?.title}
        />
      </div>

      <div>
        <FileUpload
          file={newCoverFile}
          setFile={setNewCoverFile}
          label=""
          addText={t("add_logo")}
          shape="circle"
          size={128}
          initial={cover}
        />
      </div>

      {
        loading
        ?
        <LoadingButton/>
        :
        <SubmitButton label={t("update")}/>
      }
    </form>
  );
};

export default UpdateStoreTypeForm;
